export default __webpack_public_path__ + "images/0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c.png";